import { RoutesService } from '@abp/ng.core';
import { eSaasRouteNames } from '@volo/abp.ng.saas/config';
import { APP_INITIALIZER } from '@angular/core';

export const TENANTS_ACTIVITY_TENANT_ACTIVITY_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/tenants-activity',
        name: '::Menu:TenantsActivity',
        parentName: eSaasRouteNames.Saas,
        order: 3,
        requiredPolicy: 'Enova.TenantsActivity',
      },
    ]);
  };
}
